function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import * as _ from 'lodash';
import { RenderUtils } from '@wix/photography-client-lib';
var Utils = /*#__PURE__*/function (_RenderUtils) {
  function Utils() {
    var _this;
    _this = _RenderUtils.call(this) || this;
    try {
      document.domain = 'wixapps.net';
    } catch (e) {
      // console.warn('failed to set domain');
    }
    _this.isAccessibilityEnabled(); // populate the cache with the sdk response
    return _this;
  }
  _inheritsLoose(Utils, _RenderUtils);
  var _proto = Utils.prototype;
  _proto.removeItemHashParam = function removeItemHashParam(baseUrl) {
    var itemPart = baseUrl.indexOf('pro-gallery-item=');
    // remove anything after the hash
    var newUrl = baseUrl.substr(0, itemPart > 0 ? itemPart - 1 : baseUrl.length);
    newUrl += newUrl.indexOf('#') > 0 ? '' : '#';
    return newUrl;
  };
  _proto.setStateAndLog = function setStateAndLog(that, caller, state, callback) {
    var _this2 = this;
    if (this.isVerbose()) {
      console.log("State Change Called (" + caller + ")", state);
      var oldState = _.clone(that.state);
      that.setState(state, function () {
        var newState = _.clone(that.state);
        var change = _this2.printableObjectsDiff(oldState, newState, 'state');
        if (_.keys(change).length > 0) {
          console.log("State Change Completed (" + caller + ")", change);
        }
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    } else {
      that.setState(state, function () {
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    }
  };
  _proto.printableObjectsDiff = function printableObjectsDiff(obj1, obj2, prefix) {
    if (prefix === void 0) {
      prefix = '';
    }
    var toString = function toString(v) {
      if (v === '') {
        v = "''";
      } else if (_.isUndefined(v)) {
        v = 'undefined';
      }
      return _.toString(v);
    };
    var _getInnerDiff = function getInnerDiff(obj1, obj2, prefix) {
      var innerDiff = _.reduce(obj1, function (res, v, k) {
        if (!_.isEqual(v, obj2[k])) {
          if (_.isArray(obj2[k])) {
            if (v.length !== obj2[k].length) {
              res[k + '.length'] = '[' + v.length + '] => [' + obj2[k].length + ']';
            }
            res = _.merge(res, _getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
          } else if (_.isObject(obj2[k])) {
            res = _.merge(res, _getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
          } else {
            res[(prefix ? prefix + '.' : '') + k] = toString(v) + ' => ' + toString(obj2[k]);
          }
        }
        return res;
      }, {});
      return innerDiff;
    };
    return _getInnerDiff(obj1, obj2, prefix);
  };
  _proto.getViewportScaleRatio = function getViewportScaleRatio() {
    // 320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
    if (this.isMobile() && !this.isMobileViewer() && this.isSite()) {
      return 320 / this.getScreenWidth();
    } else {
      return 1;
    }
  };
  _proto.findFontsHrefs = function findFontsHrefs() {
    try {
      var isFontHref = function isFontHref(x) {
        return x.toLowerCase().includes('font');
      };
      // eslint-disable-next-line no-undef
      var styleSheets = top.document.styleSheets;
      return Object.keys(styleSheets).map(function (s) {
        return styleSheets[s].href;
      }).filter(function (href) {
        return href !== null;
      }).filter(isFontHref);
    } catch (e) {
      // console.warn('could not find fonts hrefs', e);
      return [];
    }
  };
  _proto.colorStringToObject = function colorStringToObject(colorString) {
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    try {
      var returnValue = null;
      if (typeof colorString === 'string') {
        if (colorString.trim().indexOf('rgb') === 0) {
          // rgb(1,2,3) | rgba(4,5,6,0.7)
          var values = colorString.match(/\d+/g);
          if (values && Array.isArray(values) && values.length >= 3) {
            returnValue = {
              r: values[0],
              g: values[1],
              b: values[2]
            };
          }
        } else {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          colorString = colorString.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
          });
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorString);
          returnValue = result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }
      }
      return returnValue;
    } catch (error) {
      console.error('Error converting color string to object', error);
    }
  };
  _proto.getDateCreatedTicksFromStr = function getDateCreatedTicksFromStr(dateCreatedStr) {
    var isDateCreatedValid = isNaN(Date.parse(dateCreatedStr)) === false;
    if (isDateCreatedValid) {
      return Date.parse(dateCreatedStr);
    }
    return -8640000000000000;
  };
  return Utils;
}(RenderUtils);
export var utils = new Utils();